



























import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { SfCarousel, SfLink } from '@storefront-ui/vue';

import { useUiHelpers } from '~/composables';
import { CategoryTree } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'CategorySubChildren',
  components: {
    SfCarousel,
    SfLink,
  },
  props: {
    subcategories: {
      type: Array as PropType<CategoryTree[]>,
      default: () => [],
    },
  },
  setup() {
    const { getCatLink } = useUiHelpers();
    return {
      getCatLink,
    };
  },
});
